// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\"><defs/><path d=\"M6.34 6.34a1.14 1.14 0 011.61 0L14 12.38l6.05-6.04a1.14 1.14 0 011.61 1.61L15.62 14l6.04 6.05a1.14 1.14 0 01-1.61 1.61L14 15.62l-6.05 6.04a1.14 1.14 0 01-1.61-1.61L12.38 14 6.34 7.95a1.14 1.14 0 010-1.61z\"/></svg> ";
// Exports
module.exports = code;